/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.userprogress.bff.rpc.UserProgressBFFChirpService
 */
import * as References from './UserProgressBFFChirpService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.userprogress.bff.rpc.UserProgressBFFChirpService#getUserProgress
 */
export const GET_USER_PROGRESS_QUERY_FIELD_NAME = 'com_hubspot_userprogress_bff_rpc_UserProgressBFFChirpService_getUserProgress';
export const GET_USER_PROGRESS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_USER_PROGRESS_QUERY_FIELD_NAME,
  args: ['requestedProgress', 'includePlaylistRemainingDuration'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getUserProgressRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.userprogress.bff.rpc.UserProgressBFFChirpService#getUserLessonProgress
 */
export const GET_USER_LESSON_PROGRESS_QUERY_FIELD_NAME = 'com_hubspot_userprogress_bff_rpc_UserProgressBFFChirpService_getUserLessonProgress';
export const GET_USER_LESSON_PROGRESS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_USER_LESSON_PROGRESS_QUERY_FIELD_NAME,
  args: ['lessonId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getUserLessonProgressRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.userprogress.bff.rpc.UserProgressBFFChirpService#getUserTrackProgress
 */
export const GET_USER_TRACK_PROGRESS_QUERY_FIELD_NAME = 'com_hubspot_userprogress_bff_rpc_UserProgressBFFChirpService_getUserTrackProgress';
export const GET_USER_TRACK_PROGRESS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_USER_TRACK_PROGRESS_QUERY_FIELD_NAME,
  args: ['trackId', 'includeExpiredAwards'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getUserTrackProgressRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.userprogress.bff.rpc.UserProgressBFFChirpService#getAllUserProgressByUserId
 */
export const GET_ALL_USER_PROGRESS_BY_USER_ID_QUERY_FIELD_NAME = 'com_hubspot_userprogress_bff_rpc_UserProgressBFFChirpService_getAllUserProgressByUserId';
export const GET_ALL_USER_PROGRESS_BY_USER_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ALL_USER_PROGRESS_BY_USER_ID_QUERY_FIELD_NAME,
  args: ['language'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getAllUserProgressByUserIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});